module.exports = __webpack_public_path__ + "img/image63.aea79ce9.png";